import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsService } from '../../../services/documents.service';
import { FormControl, Validators } from '@angular/forms';
import { SubjectSelectorModalComponent } from '../subject-selector-modal/subject-selector-modal.component';
import { ListCustomfieldDynamicComponent } from '../list-customfield-dynamic/list-customfield-dynamic.component';
import { Section } from '../../shared/model/section.model';
import { CustomfieldsService } from 'src/app/services/customfields.service';
import { Customfield } from 'src/app/docuvision/models/customfield.model';
import { saveChange, getTime } from '../../util/util';
import { UsersService } from '../../../services/users.service';
import { Subject } from '@app/trackvision/shared/model/subject.model';

declare var $: any;

@Component({
    selector: 'app-text-editor-modal',
    templateUrl: './text-editor-modal.component.html',
    styleUrls: ['../documents.component.scss', './text-editor-modal.component.scss'],
    standalone: false
})
export class TextEditorModalComponent implements OnInit {

  mode: 'edit' | 'create' | 'header' | 'createClause' | 'editClause'

  sectionIndex: number

  _section: Section

  summernoteConfig = {
    height: '20rem'
  }

  nameField: FormControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  contentField: FormControl = new FormControl('');

  displayErrors: boolean = false
  errors: string[] = []

  _requirementtypeid: number

  customFields: Customfield[] = []
 
  dynamicfield: Array <any>

  showMessage: boolean = false

  constructor(
    public activeModal: NgbActiveModal,
    public documentsService: DocumentsService,
    public modalService: NgbModal,
    public customfieldsService: CustomfieldsService,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.nameField = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  }

  set section(section: Section) {
    this.addComponenEditor()
    this.nameField = new FormControl(section.name, [
      Validators.required,
      Validators.maxLength(50)
    ])
    if (section.content) $('#summernote').summernote('code', section.content)
    this._section = section
  }

  get section(): Section {
    return this._section
  }

  public set headerHtml(content: string) {
    this.addComponenEditor()
    $('#summernote').summernote('code', content)
  }

  public set requirementtypeid(id : number) {
    this._requirementtypeid = id
    this.customfieldsService.getCustomfieldsByRequirementType(this._requirementtypeid).subscribe(response => {
      for (const group of response['result']) {
        this.customFields = this.customFields.concat(group['fields'])
      }
    })
  }

  openSubjectSelector() {
    if (!this.nameField.valid) {
      this.displayErrors = true
      return
    }
    const subjectModal = this.modalService.open(SubjectSelectorModalComponent, {size: 'lg'})
    subjectModal.componentInstance.title = 'Selecciona la submateria de la cláusula'
    subjectModal.componentInstance.parentid = this._section.subjectparentid
    subjectModal.componentInstance.subjectid = this._section.subjectid

    subjectModal.result
      .then( result => this.saveSection(result.subject.id) )
      .catch(() => {})
  }

  openCustomfieldSelector() {

    const subjectModal = this.modalService.open(ListCustomfieldDynamicComponent, {size: 'lg'})
    subjectModal.componentInstance.title = 'Listado de campos creados.'
    subjectModal.componentInstance.dynamicfield = this.dynamicfield

    subjectModal.result.then(value => {
      this.dynamicfield = value
    })

  }

  async saveSection(submateriaId: number) {
    this.addComponenEditor()
    if (this.mode == 'editClause') {
      try {
        const content = $('#summernote').summernote('code')
        const result = await this.documentsService.updateSection({
          id: this._section.id,
          name: this.nameField.value,
          content: this.stylesControl(content),
          subjectid: submateriaId
        }).toPromise()
  
        if (result['error']) {
          this.errors.push(result['error']['message'])
          this.displayErrors = true
        } else {
          this.activeModal.close({
            section: {
              id: this._section.id,
              name:this.nameField.value,
              content: this.stylesControl(content),
              subjectid: submateriaId
            }
          })
        }
      } catch (error) {}
    } else {
      try {
        const content = $('#summernote').summernote('code')
        const result = await this.documentsService.createSection({
          name: this.nameField.value,
          content: this.stylesControl(content),
          subjectid: submateriaId
        }).toPromise()
  
        if (result['error']) {
          this.errors.push(result['error']['message'])
          this.displayErrors = true
        } else {
          this.activeModal.close({
            section: {
              name:this.nameField.value,
              content: this.stylesControl(content),
              subjectid: submateriaId
            },
            index:null,
            db:true
          })
        }
      } catch (error) {}
    }
  }

  copyFieldToClipboard(field: Customfield) {
    const selBox = document.createElement('textarea')
    selBox.style.position = 'fixed'
    selBox.style.left = '0'
    selBox.style.top = '0'
    selBox.style.opacity = '0'
    selBox.value = `{%${field.name}/${field.id}%}`
    document.body.appendChild(selBox)
    selBox.focus()
    selBox.select()
    document.execCommand('copy')
    document.body.removeChild(selBox)

    this.showMessage = true
    setTimeout(
      () => this.showMessage = false,
    5000)
  }

  closeError(error: string) {
    this.errors.splice(this.errors.indexOf(error), 1);
  }

  returnSection() {
    const user = this.usersService.getUserData()
    const content = $('#summernote').summernote('code')
    let time = getTime()
    this.documentsService.unsavedChanges = saveChange('addContenido', user.name, null, time)
 
    const newSection = {...this._section}
    newSection.content = this.stylesControl(content)
    newSection.name = this.nameField.value || undefined

    this.activeModal.close({
      section: newSection,
      index: this.sectionIndex,
      db: false,
      dynamicfield: this.dynamicfield
    })
  }

  returnHeader() {
    const user = this.usersService.getUserData()
    let time = getTime()
    this.activeModal.close($('#summernote').summernote('code'))
    this.documentsService.unsavedChanges = saveChange('addContendHeader', user.name, null, time)

  }

  stylesControl(content: string){
    const html = content
      .replace(/<img/g, '<img style="width:50%"')
      .replace(/<h1>/g, '<h1 style="font-size:12pt">')
      .replace(/<h2>/g, '<h2 style="font-size:10pt">')
      .replace(/<h3>/g, '<h3 style="font-size:8pt">')
      .replace(/<tr>/g, '<tr style="border: hidden">')

    return html
  }
  addComponenEditor(){
    $('#summernote').summernote({
      fontSizes: ['8', '9', '10', '11', '12', '13', '14', '15', '16', , '17', '18'],
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['picture'],
        ['link'],
        ['table'],
        ['height', ['height']]   
      ]
    });
    
  }
}
